export const SnackBarType = {
    FAIL: "messenger-fail",
    WANING: "messenger-waning",
    SUCCESS: "messenger-success"
}